<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
import merge from 'lodash/merge';
import SelectInfinite from '~/components/select/components/select_infinite';
import OrganizationUsers from '~/api/organization_users';

Vue.use(Select);
Vue.use(Option);

export default {
    name: 'organization-user-select',

    components: {
        SelectInfinite,
    },

    model: {
        prop: 'value',
        event: 'change',
    },

    props: {
        inputName: {
            type: String,
            default: null,
        },

        multiple: {
            type: Boolean,
            default: false,
        },

        placeholder: {
            type: String,
            default: 'Type a user\'s name',
        },

        value: {
            type: [String, Number, Array],
            default: null,
        },

        params: {
            type: Object,
            default() {
                return {};
            },
        },

        method: {
            type: Function,
            default: OrganizationUsers.searchUsers,
        },

        prependOptions: Array,

        required: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selectedValue: this.multiple ? [] : null,
        };
    },

    computed: {
        selectedValueAsArray() {
            return this.multiple ? this.selectedValue : [this.selectedValue];
        },

        inputNameComputed() {
            return this.multiple ? `${this.inputName}[]` : this.inputName;
        },
    },

    watch: {
        value: {
            handler(val) {
                // Convert to string to match options.
                if (this.multiple) {
                    this.selectedValue = Array.isArray(val)
                        ? val.map((v) => `${v}`)
                        : [];
                } else if (val === null) {
                    this.selectedValue = val;
                } else {
                    this.selectedValue = `${val}`;
                }
            },
            immediate: true,
        },
    },

    methods: {
        remoteMethod(params) {
            const mergedParams = merge({}, this.params, params);
            return this.method(mergedParams);
        },

        remoteValueMethod(val) {
            return this.method({
                columns: [{
                    name: 'include_users',
                    value: val instanceof Array ? val.join(',') : val,
                }],
            });
        },

        onChange(value, full) {
            this.$emit('change', value, full);
            $(document).trigger('el-select:change', [this.inputNameComputed, value]);
        },
    },
};
</script>

<template>
    <div>
        <input
            v-for="val in selectedValueAsArray"
            v-if="inputName"
            v-show="false"
            :key="val"
            :name="inputNameComputed"
            :value="val"
            :required="required"
        >
        <select-infinite
            ref="select"
            v-model="selectedValue"
            option-value="user_id"
            option-key="user_id"
            option-label="user_name"
            :placeholder="placeholder"
            :multiple="multiple"
            :remote-method="remoteMethod"
            :remote-value-method="remoteValueMethod"
            :prepend-options="prependOptions"
            @change="onChange"
            @input="$emit('input', $event)"
        >
            <template slot-scope="props">
                <slot :item="props.item" />
            </template>
        </select-infinite>
    </div>
</template>
